class loadMoreProjects extends HTMLElement {
    constructor(){
        super();
        
        this.loadBtn = this.querySelector('a.button-load-more');
    }

    connectedCallback(){
        this.loadBtn.addEventListener('click', this.clickLoad.bind(this));
    }

    clickLoad(evnt){
        evnt.preventDefault();
        let elment_current = evnt.currentTarget;
        elment_current.dataset.paged = parseInt(elment_current.dataset.paged, 10) + 1; 
        elment_current.classList.add('disabled');
        elment_current.querySelector('.loader').style.cssText = 'display: block;';
        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            headers: new Headers({
              'Content-Type': 'application/x-www-form-urlencoded',
              'Cache-Control': 'no-cache',
            }),
            body: new URLSearchParams(
              {
                action: 'load_more_porjects',
                paged: evnt.currentTarget.dataset.paged,
                term: ''//document.querySelector('blog-posts-filter').querySelector('.tab.active').dataset.id
              }
            ),
          })
          .then(response => response.json())
          .then(response => {
            let response_text = response.data.more;
            if(response.success){
                document.querySelector('#feed-porjects-loop .content').insertAdjacentHTML('beforeend', response_text);
                elment_current.classList.remove('disabled')
                elment_current.querySelector('.loader').style.cssText = 'display: none;';
            } else if (!response.success && response.data.more == null ) {
                elment_current.querySelector('.loader').style.cssText = 'display: none;';
            }
            
            if(response.data.last) { elment_current.classList.add('hidden')}
            else{ elment_current.classList.remove('hidden') }
        })
        .catch(err => () => {
            console.error(err);
        });
    }
}
customElements.define('load-moreprojects', loadMoreProjects);